<script setup lang="ts">
import { VBreadCrumbs } from '@/shared/ui'
import './assets/style.scss'
import { useMeta } from '@/shared/lib'
import { toRefs } from 'vue'

const { data } = toRefs(useMeta())
</script>

<template>
  <div class="w-content-header">
    <div class="w-content-header__breadcrumbs">
      <VBreadCrumbs />
    </div>
  </div>
</template>
